export const KM_RADIUS_UNIT = 'sellWine.addOffer.distribution.kilometer'
export const M_RADIUS_UNIT = 'sellWine.addOffer.distribution.meter'

export const radiusUnitId = {
  km: 12,
  m: 13,
}
